module.exports = __webpack_public_path__ + "static/media/dislike.113fa643.png";